import { render } from "./Indispos.vue?vue&type=template&id=57df3229"
import script from "./Indispos.vue?vue&type=script&lang=ts"
export * from "./Indispos.vue?vue&type=script&lang=ts"

import "./Indispos.vue?vue&type=style&index=0&id=57df3229&lang=scss"
script.render = render

export default script